// Explicit collection registry barrel.
import { blogCollection } from './blog';
import { discoverCollection } from './discover';
import { featuresCollection } from './features';
import { gamesCollection } from './games';
import { reportsCollection } from './reports';
export const collections = [
    discoverCollection,
    gamesCollection,
    featuresCollection,
    blogCollection,
    reportsCollection,
];
export * from './blog';
export * from './discover';
export * from './features';
export * from './games';
export * from './reports';
//# sourceMappingURL=index.js.map